/* global window */
import { errorCode, errorTracking } from './standardErrors';
import store from '../../store';
import { removeBlankKeys } from '../../components/material-ui/helper';
import Utils, { getSessionStorage } from '../../utils';
import requestService from '../services/requestService';
import { route } from 'preact-router';
import { loginRoute } from '../../alias/homeRoutes';
import { clearLoginData } from '../../utils/helper';

const httpResponse = (status, data) => {
  if (status >= 300 || status < 200) {
    if (status === 401) {
      const errorData = {
        errorCode: 401,
        errorMessage: 'Authorization Fail',
      };
      return { status, data: errorData, statusText: 'FAIL' };
    }
    const { code } = data || {};
    const state = store.getState();
    const { config } = state || {};
    const { template } = config || {};
    const errorData = {
      ...data,
      errorCode: errorCode['payment'][codeDecorator(code)],
    };
    if (code) {
      errorTracking({
        errorName: errorCode['payment'][codeDecorator(code)],
        code,
        errorData,
      });
    }
    return { status, data: errorData, statusText: 'FAIL' };
  }
  return { status, data, statusText: 'OK' };
};

const codeDecorator = (code) => {
  const { paymentUserData } = store.getState();
  const { selectedLender } = paymentUserData || {};
  const { aivfType } = selectedLender || {};
  if (aivfType === 'PIN') {
    if (code === 4105) {
      return 4104;
    } else if (code === 4303) {
      return 4302;
    } else {
      return code;
    }
  }
  return code;
};

const authenticationHeaders = () => {
  const { sessionToken, pinAuthToken, sessionId } = extractHeaders() || {};
  return removeBlankKeys({
    'session-token': sessionToken,
    'pin-setup-auth-token': pinAuthToken,
    sessionId: sessionId,
    ...store.getState().widgetData.widgetHeaders,
  });
};
const extractHeaders = () => {
  const sessionToken = getSessionStorage('sessionToken');
  const pinAuthToken = getSessionStorage('pinAuthToken');
  // SessionId header is used in NTB code.
  // Android Java code sets cookie value for a URL which is then read and used by javascript.
  const sessionId = Utils.getCookie('sessionId');
  return {
    sessionToken,
    pinAuthToken,
    sessionId,
  };
};

const authAPIDecorator = (...args) => {
  return requestService(...args)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.status === 401) {
        clearLoginData();
        route(loginRoute.path);
      }
      throw error;
    });
};

export { authenticationHeaders, httpResponse, authAPIDecorator };



// WEBPACK FOOTER //
// ./components/transaction/src/api/helpers/index.js